import { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

// Peacock components
import { TabsNavigation, Tab } from 'pepsico-ds';

// Custom Components
import { ProfileManagementViewHeader } from '@/components/features/profile-management/ProfileManagementHeader/ProfileManagementViewHeader';
// Constants
import { ROUTES } from '@/utils/constants/routesConstants';

const ProfileManagementView = () => {
  // Access the storeId parameter from the URL
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  // Effect to sync the selected tab with the current URL path
  useEffect(() => {
    const path = location.pathname;
    // Map URL paths to their corresponding tab indexes
    if (path.includes(ROUTES.PROFILE_MANAGEMENT_CUSTOMERS)) {
      setSelectedTabIndex(0); // Customer View tab
    } else if (path.includes(ROUTES.PROFILE_MANAGEMENT_STORES)) {
      setSelectedTabIndex(1); // Store View tab
    }
  }, [location.pathname]);

  // Handler for tab click events
  const handleTabClick = index => {
    // Update the selected tab state
    setSelectedTabIndex(index);
    // Navigate to the corresponding route based on tab index
    switch (index) {
      case 0:
        navigate(ROUTES.PROFILE_MANAGEMENT_CUSTOMERS); // Customer View
        break;
      case 1:
        navigate(ROUTES.PROFILE_MANAGEMENT_STORES); // Store View
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <ProfileManagementViewHeader />

      <div className='mb-6 mt-10'>
        <TabsNavigation isDark={true} selectedIndex={selectedTabIndex}>
          <Tab
            className='bg-[#131313]'
            label='Customer View'
            onClick={() => handleTabClick(0)}
          />
          <Tab
            className='bg-[#131313]'
            label='Store View'
            onClick={() => handleTabClick(1)}
          />
        </TabsNavigation>
      </div>

      <div className=''>
        <Outlet />
      </div>
    </div>
  );
};

export default ProfileManagementView;
